import { uniq, uniqBy } from 'lodash';
import { putDevice } from '@alice/shared/api/devices';
import {
  fetchUsers,
  getUserById,
  postUser,
  putUser,
} from '@alice/shared/api/users';
import { getCurrentUser, logout as logoutAPI } from '../../api/auth';

export const APPEND_USERS = 'APPEND_USERS';
export const REFRESH_USERS = 'REFRESH_USERS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const NEW_SESSION = 'NEW_SESSION';
export const REMOVE_USER = 'REMOVE_USER';
export const MERGE_USER = 'MERGE_USER';

export const removeUserById = (payload) => ({ type: REMOVE_USER, payload });

export const getUsers = () => (dispatch) =>
  fetchUsers().then((users) =>
    dispatch({ type: APPEND_USERS, payload: users }),
  );

export const refreshUsers = () => (dispatch) =>
  fetchUsers().then((payload) => dispatch({ type: REFRESH_USERS, payload }));

export const fetchUserById = (id) => (dispatch) =>
  getUserById(id).then((user) =>
    dispatch({ type: APPEND_USERS, payload: [user] }),
  );

export const clearSession = () => (dispatch) => {
  return logoutAPI().then(() => {
    dispatch({ type: CLEAR_SESSION });
  });
};

export const updateSession = (payload) => ({ type: NEW_SESSION, payload });

// Updated to work with session-based auth
export const syncUserData = () => (dispatch) => {
  return getCurrentUser().then((user) => {
    if (user) {
      dispatch({ type: NEW_SESSION, payload: user });
    }
    return user;
  });
};

// Self-signup: creates user account and auto-logs them in
export const signup = (form) => (dispatch) => {
  return postUser(form)
    .then(() => {
      // After signup, fetch the current user (server auto-creates session)
      return getCurrentUser();
    })
    .then((user) => {
      if (user) {
        dispatch({ type: NEW_SESSION, payload: user });
      }
      return user;
    });
};

export const updateUserDevice = (newDevice) => (dispatch, getState) => {
  const state = getState();
  const user = state.users.session;
  const userDevices = user.devices || [];
  return putDevice(newDevice.deviceId, newDevice).then((savedDevice) => {
    const devices = uniq([savedDevice.deviceId, ...userDevices]);
    const devicesPopulated = uniqBy(
      [savedDevice, ...user.devicesPopulated],
      'deviceId',
    );

    const defaultDeviceId = newDevice.isDefaultDeviceId
      ? savedDevice.deviceId
      : user.defaultDeviceId;
    let promise = Promise.resolve();
    if (
      userDevices.length !== devices.length ||
      defaultDeviceId !== user.defaultDeviceId
    ) {
      promise = putUser(user._id, { devices, defaultDeviceId });
    }
    return promise.then(() => {
      dispatch({
        type: MERGE_USER,
        payload: {
          defaultDeviceId,
          devices,
          devicesPopulated,
        },
      });
    });
  });
};

export const updateUser = (changes) => (dispatch, getState) => {
  const state = getState();
  const user = state.users.session;
  return putUser(user._id, changes).then(() => {
    dispatch({ type: MERGE_USER, payload: changes });
  });
};
